import { FC, SVGAttributes } from "react";

const IdealIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Ideal</title>
    <path
      d="M3.712 0.5H28.288C30.0493 0.5 31.5 1.95884 31.5 3.78681V20.2132C31.5 22.0411 30.0493 23.5 28.288 23.5H3.712C1.95064 23.5 0.5 22.0411 0.5 20.2132V3.78681C0.5 1.95884 1.95064 0.5 3.712 0.5Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <mask
      id="mask0_8127_237"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="24"
    >
      <path
        d="M3.712 0.5H28.288C30.0493 0.5 31.5 1.95884 31.5 3.78681V20.2132C31.5 22.0411 30.0493 23.5 28.288 23.5H3.712C1.95064 23.5 0.5 22.0411 0.5 20.2132V3.78681C0.5 1.95884 1.95064 0.5 3.712 0.5Z"
        fill="white"
        stroke="white"
      />
    </mask>
    <g mask="url(#mask0_8127_237)">
      <mask
        id="mask1_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="12"
        width="4"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.91199 12.8802H12.6685V17.1524H9.91199V12.8802Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.41243 10.5468H15.1686V19.4859H7.41243V10.5468Z"
          fill="#0A0B09"
        />
      </g>
      <mask
        id="mask2_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="9"
        width="4"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.317 9.28766C12.1787 9.28766 12.8773 9.93978 12.8773 10.7441C12.8773 11.5484 12.1787 12.2008 11.317 12.2008C10.4553 12.2008 9.75665 11.5484 9.75665 10.7441C9.75665 9.93978 10.4553 9.28766 11.317 9.28766Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.25662 6.95435H15.377V14.5343H7.25662V6.95435Z"
          fill="#0A0B09"
        />
      </g>
      <mask
        id="mask3_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="5"
        width="18"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8898 5C19.972 5.03501 21.731 5.59708 22.9841 6.63656C23.6956 7.22677 24.2448 7.96813 24.6164 8.84006C25.0049 9.75151 25.2019 10.8146 25.2019 11.9999C25.2019 14.4793 24.453 16.3313 22.976 17.5042C21.8049 18.4342 20.1718 18.9332 18.1196 18.9923L17.8898 18.9971L17.8894 18.9983L8 18.9981V5L17.8898 5ZM17.703 5.92981H8.99645V18.0699H17.703C22.0789 18.0699 24.206 16.0843 24.206 11.9999C24.206 9.93888 23.5724 8.36827 22.3227 7.3316C21.2172 6.41454 19.6197 5.92981 17.703 5.92981Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.50056 2.66658H27.7022V21.3331H5.50056V2.66658Z"
          fill="#0A0B09"
        />
      </g>
      <mask
        id="mask4_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="7"
        width="11"
        height="11"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2895 7.06177C20.2055 7.06177 23.3093 8.13591 23.3093 12.1227C23.3093 16.3375 20.2055 17.1572 17.2895 17.1572H13.9342V7.06177H17.2895Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4344 4.72835H25.8092V19.4906H11.4344V4.72835Z"
          fill="#D52472"
        />
      </g>
      <mask
        id="mask5_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2917 9.66782C14.5082 9.66782 14.6732 9.68328 14.7868 9.7142C14.9394 9.75617 15.0701 9.83075 15.1789 9.93791C15.2878 10.0451 15.3706 10.1762 15.4274 10.3314C15.4842 10.4866 15.5126 10.678 15.5126 10.9056C15.5126 11.1055 15.4859 11.2778 15.4327 11.4225C15.3676 11.5993 15.2748 11.7423 15.1541 11.8517C15.063 11.9346 14.94 11.9992 14.785 12.0456C14.6691 12.0798 14.5141 12.0969 14.3201 12.0969H13.3317V9.66782H14.2917ZM14.0933 10.0796H13.8567V11.6851H14.2498C14.3968 11.6851 14.503 11.6774 14.5682 11.662C14.6536 11.6422 14.7244 11.6085 14.7808 11.5611C14.8371 11.5137 14.8831 11.4357 14.9187 11.3272C14.9542 11.2186 14.972 11.0706 14.972 10.8832C14.972 10.6958 14.9542 10.5519 14.9187 10.4516C14.8831 10.3513 14.8333 10.273 14.7692 10.2168C14.7052 10.1606 14.6239 10.1226 14.5255 10.1027C14.452 10.0873 14.3079 10.0796 14.0933 10.0796Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.832 7.33437H18.0125V14.4303H10.832V7.33437Z"
          fill="white"
        />
      </g>
      <mask
        id="mask6_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2916 9.60141C14.5169 9.60141 14.6854 9.61746 14.8068 9.6505C14.9708 9.69561 15.1133 9.77696 15.2304 9.89221C15.3458 10.0058 15.4347 10.1464 15.4945 10.31C15.5536 10.4714 15.5836 10.6718 15.5836 10.9056C15.5836 11.1119 15.5554 11.2931 15.4998 11.4441C15.4314 11.63 15.3318 11.7832 15.2036 11.8993C15.105 11.989 14.9714 12.0595 14.8063 12.1089C14.684 12.145 14.5203 12.1634 14.32 12.1634H13.2604V9.60141H14.2916ZM14.2914 9.73418H13.4026V12.0305H14.3198C14.5056 12.0305 14.6548 12.0142 14.763 11.9823C14.9067 11.9393 15.0215 11.8793 15.1043 11.804C15.2163 11.7025 15.304 11.5669 15.3651 11.4009C15.4156 11.2638 15.4411 11.0972 15.4411 10.9055C15.4411 10.6864 15.4138 10.5004 15.3598 10.3529C15.3066 10.2075 15.2283 10.0832 15.127 9.98356C15.0274 9.88548 14.9061 9.81627 14.7666 9.77791C14.66 9.74887 14.5002 9.73418 14.2914 9.73418Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7607 7.26796H18.0835V14.4967H10.7607V7.26796Z"
          fill="white"
        />
      </g>
      <mask
        id="mask7_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="10"
        width="3"
        height="2"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.093 10.0131C14.3149 10.0131 14.4614 10.0212 14.5403 10.0377C14.6511 10.0601 14.7445 10.1041 14.8178 10.1684C14.8902 10.232 14.9468 10.3203 14.986 10.4307C15.0243 10.5388 15.0429 10.6868 15.0429 10.8832C15.0429 11.079 15.0245 11.2306 14.9864 11.3465C14.9467 11.468 14.8949 11.5543 14.8282 11.6104C14.7633 11.665 14.6816 11.704 14.5855 11.7263C14.5139 11.7433 14.404 11.7515 14.2496 11.7515H13.7853V10.0131H14.093ZM14.0924 10.1459H13.927V11.6187H14.2489C14.3894 11.6187 14.4907 11.6116 14.5501 11.5975C14.6237 11.5804 14.685 11.5516 14.7323 11.5118C14.7786 11.4727 14.8182 11.4041 14.8497 11.3077C14.8831 11.2059 14.9 11.0631 14.9 10.8831C14.9 10.7037 14.8832 10.5655 14.8502 10.4724C14.8186 10.3832 14.7746 10.3135 14.7196 10.2652C14.6654 10.2176 14.5948 10.1848 14.509 10.1675C14.4622 10.1576 14.3519 10.1459 14.0924 10.1459Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.285 7.6797H17.5424V14.0849H11.285V7.6797Z"
          fill="white"
        />
      </g>
      <mask
        id="mask8_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0324 9.66782V10.0796H16.6307V10.6176H17.9346V11.0293H16.6307V11.6852H18.0822V12.0969H16.106V9.66782H18.0324Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.606 7.33437H20.582V14.4303H13.606V7.33437Z"
          fill="white"
        />
      </g>
      <mask
        id="mask9_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.104 9.60141V10.146H16.7022V10.5512H18.0061V11.0958H16.7022V11.6188H18.1538V12.1634H16.0352V9.60141H18.104ZM17.9618 9.73418H16.1777V12.0305H18.0116V11.7515H16.5601V10.9629H17.864V10.6839H16.5601V10.0131H17.9618V9.73418Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5357 7.26796H20.654V14.4967H13.5357V7.26796Z"
          fill="white"
        />
      </g>
      <mask
        id="mask10_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="18"
        y="9"
        width="4"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9801 9.66782L21.0209 12.0969H20.4492L20.2221 11.5457H19.1824L18.967 12.0969H18.4095L19.4208 9.66782H19.9801ZM19.6944 10.234L19.3429 11.1339H20.0531L19.6944 10.234Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9095 7.33437H23.5205V14.4303H15.9095V7.33437Z"
          fill="white"
        />
      </g>
      <mask
        id="mask11_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="18"
        y="9"
        width="4"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0283 9.60141L21.1259 12.1634H20.4003C20.4003 12.1634 20.2031 11.6846 20.1732 11.6121H19.2322C19.2033 11.6862 19.0168 12.1634 19.0168 12.1634H18.3055L19.3721 9.60141H20.0283ZM19.9323 9.73418H19.4698C19.437 9.81287 18.5824 11.8658 18.5138 12.0305H18.9175C18.9465 11.9564 19.1329 11.4792 19.1329 11.4792H20.2713C20.2713 11.4792 20.4685 11.958 20.4983 12.0305H20.9161C20.8451 11.8647 19.9655 9.81176 19.9323 9.73418Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.806 7.26796H23.6261V14.4967H15.806V7.26796Z"
          fill="white"
        />
      </g>
      <mask
        id="mask12_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="19"
        y="10"
        width="2"
        height="2"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.6945 10.0418L20.1563 11.2003H19.242L19.6945 10.0418ZM19.6959 10.4261C19.6193 10.6221 19.4901 10.9529 19.4453 11.0674H19.9516C19.9057 10.9524 19.7738 10.6217 19.6959 10.4261Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask12_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7424 7.70833H22.6564V13.5336H16.7424V7.70833Z"
          fill="white"
        />
      </g>
      <mask
        id="mask13_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="21"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9849 9.68777V11.6852H23.2923V12.097H21.4601V9.68777H21.9849Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9599 7.35439H25.7918V14.4304H18.9599V7.35439Z"
          fill="white"
        />
      </g>
      <mask
        id="mask14_8127_237"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="21"
        y="9"
        width="3"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0559 9.62131V11.6187H23.3633V12.1633H21.3888V9.62131H22.0559ZM21.913 9.75414H21.5305V12.0305H23.2204V11.7516H21.913V9.75414Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask14_8127_237)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8886 7.28792H25.8628V14.4967H18.8886V7.28792Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

export default IdealIconBackground;
